// The area's own perspective shot (#437): one tile beside the area name, and a
// red flag on the area and in the area list until it has one. The flag never
// blocks surfaces, sync or pricing.
import { ImageOff } from 'lucide-react';
import { Label } from '@higgins/ui';
import { areaPhotoOf, shownPhotos, type PhotoSources, type ShownPhoto } from '../lib/area-photos';
import type { DeviceRecord } from '../lib/device-db';
import { AREA_PHOTO } from '../lib/jobs';
import { PhotoStrip } from './photo-strip';

export function AreaPhotoFlag() {
  return (
    <span className="inline-flex items-center gap-1 whitespace-nowrap rounded bg-red-50 px-1.5 py-0.5 text-xs font-medium text-red-700">
      <ImageOff className="h-3.5 w-3.5" aria-hidden="true" /> Feature photo required
    </span>
  );
}

/** The flag for one area, wherever it is shown (the area list, the Assess and Condition tabs); `sources` are the job's photos, read once by the page. */
export function AreaPhotoMissing({ area, sources }: { area: DeviceRecord; sources: PhotoSources }) {
  if (areaPhotoOf(shownPhotos(area, sources))) return null;
  return <AreaPhotoFlag />;
}

interface TileProps {
  jobId: string;
  areaId: string;
  /** The feature photo; null = none yet. */
  photo: ShownPhoto | null;
}

/** The feature photo: Take photo / Upload photo until there is one, then its thumbnail (tap to view) and the way to replace it. */
export function AreaPhotoTile({ jobId, areaId, photo }: TileProps) {
  return (
    <div>
      <Label>Feature photo</Label>
      <div className="mt-1">
        <PhotoStrip jobId={jobId} areaId={areaId} surface={AREA_PHOTO} photos={photo ? [photo] : []} />
      </div>
    </div>
  );
}
